/*************************************************/
/* MATERIAL PREVIEW                              */
/*************************************************/

export function materialPreview() {
    const thumbnailSelector = ".material__thumbnail";
    const previewSelector = ".material__preview";
    const mainImageSelector = ".material__main-image";

    const init = () => {
       const thumbnails = document.querySelectorAll(thumbnailSelector);
       if(thumbnails != null) {
           thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click",(e) => {
                const thumbnailElement = e.target;
                const previewElement = thumbnailElement.closest(previewSelector);
                if(previewElement != null) {
                    const mainImage = previewElement.querySelector(mainImageSelector);
                    if(mainImage != null) {
                        mainImage.src = thumbnailElement.dataset.mainImageUrl;
                    }
                }
               
            });
           });
       }
    };

    init();
}
